import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import ConectUs from "../../components/ConectUs";
import { motion } from "framer-motion";
import OfferPresencial from "../../components/view/OfferPresencial";
import BlockLeftImage from "../../components/BlockLeftImage";

import Modal from "../../components/Modal";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/6c1024f7-f270-434b-9529-da6816afe2d2" +
  "?include=field_imagen_portada.field_media_image,field_imagen3.field_media_image,field_imagen4.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_imagen3,field_imagen4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Presencial() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
      <div className="mt-10">
        <img src={data.imagen_portada} alt="cabecera" />{" "}
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 p-6 shadow-xl border border-[#febe10]/20 max-w-5xl mx-auto my-8"
      >
        {/* Efectos de luz de fondo institucionales */}
        <div className="absolute top-0 right-0 -mt-12 -mr-12 w-72 h-72 bg-[#febe10]/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 -mb-12 -ml-12 w-72 h-72 bg-[#004270]/40 rounded-full blur-3xl pointer-events-none" />

        {/* Inyección de HTML con estilos usando colores de la UTPL */}
        <div
          dangerouslySetInnerHTML={{ __html: data.texto_portada }}
          className="relative z-10 flex flex-col items-start gap-4
      
      /* Estilos para el Periodo (p) - Badge en Amarillo UTPL */
      [&_h4]:text-xs 
      [&_h4]:font-bold 
      [&_h4]:tracking-widest 
      [&_h4]:uppercase 
      [&_h4]:text-[#febe10] 
      [&_h4]:bg-[#febe10]/10 
      [&_h4]:px-3 
      [&_h4]:py-1.5 
      [&_h4]:rounded-full 
      [&_h4]:border 
      [&_h4]:border-[#febe10]/30
      
      /* Estilos para el Título (h2) */
      [&_h2]:text-2xl 
      [&_h2]:md:text-3xl 
      [&_h2]:font-bold 
      [&_h2]:text-white 
      [&_h2]:tracking-tight 
      [&_h2]:leading-tight
      [&_h2]:max-w-3xl
      [&_h2]:m-0
      [&_h2]:p-0
       [&_h2_strong]:text-[#febe10]
      
      /* Estilos para el Botón si viene como enlace (a) */
      [&_a]:inline-flex 
      [&_a]:items-center 
      [&_a]:justify-center 
      [&_a]:px-6 
      [&_a]:py-3 
      [&_a]:mt-2
      [&_a]:text-sm 
      [&_a]:font-bold 
      [&_a]:text-slate-900 
      [&_a]:bg-[#febe10] 
      [&_a]:hover:bg-[#e0a60b] 
      [&_a]:rounded-xl 
      [&_a]:shadow-lg 
    
      [&_a]:transition-all 
      [&_a]:duration-200 
      [&_a]:hover:scale-[1.02]"
        />
      </motion.div>
      <section className="max-w-6xl m-auto px-6  sm:px-0">
        <div
          className="button-a grid grid-cols-1 sm:grid-cols-2 sm gap-6
  [&_h4]:text-xs
  [&_h4]:inline-flex
    [&_h4_strong]:text-xs
   [&_h4]:px-4
    [&_h4]:py-2
   [&_h4]:m-0
    [&_h4]:rounded-3xl
  [&_h4]:border 
  [&_h4]:border-gray-200 
  [&_h4]:bg-slate-100 
  [&_h4]:text-[#004270]  
  "
        >
          {data.bloque1 && (
            <div
              className="border  p-4 rounded-3xl"
              dangerouslySetInnerHTML={{
                __html: data.bloque1,
              }}
            />
          )}

          {data.bloque2 && (
            <div
              className="border  p-4 rounded-3xl"
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          )}
        </div>
      </section>
      <div className="pb-16 pt-4">
        <OfferPresencial></OfferPresencial>
      </div>
      <div className="bg-slate-50">
        <BlockLeftImage
          src={data.imagen3}
          content={
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque3,
                }}
              />
              <div className="mt-10">
                <Modal
                  title="Conoce las temáticas de la prueba"
                  content={
                    <>
                      <img src={data.imagen4} alt="utpl"></img>
                    </>
                  }
                ></Modal>{" "}
              </div>
            </>
          }
        ></BlockLeftImage>
      </div>
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="padding2 mt-10">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes presenciales."
          facebook="https://www.facebook.com/utplpresencial/"
          instagram="https://www.instagram.com/utpl/"
          tiktok="https://www.tiktok.com/@utpl.ec"
        ></ConectUs>
      </div>
    </>
  );
}

export default Presencial;
